class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", (event) => {
      if (event.target.name === "sort_by") {
        return;
      }
      if (event.target.classList.contains("mobile-facets__checkbox")) {
        return;
      }
      // Skip US market custom price filter inputs - handled by market-price-sort.js
      if (
        event.target.classList.contains("us-price-filter__min") ||
        event.target.classList.contains("us-price-filter__max")
      ) {
        return;
      }
      const form = event.target.closest("form");
      if (
        form &&
        (form.id === "FacetFiltersForm" || form.id === "FacetFiltersFormMobile")
      ) {
        return;
      }
      this.debouncedOnSubmit(event);
    });

    facetForm.addEventListener("change", (event) => {
      if (event.target.name !== "sort_by") {
        return;
      }

      this.onSubmitHandler(event);

      const form = event.target.closest("form");
      if (form && form.id === "FacetSortMobileForm") {
        const drawer = form.closest(".mobile-sort__wrapper");
        const summary = drawer?.querySelector("summary");
        if (summary) {
          summary.click();
        }
      }
    });

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderPaginateNext(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderPaginateNext(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderPaginateNext(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const newPaginateNext = parsedHTML.getElementById("paginateNext");
    const currentPaginateNext = document.getElementById("paginateNext");

    if (!newPaginateNext || !currentPaginateNext) return;

    currentPaginateNext.dataset.nextUrl =
      newPaginateNext.dataset.nextUrl || "";
    currentPaginateNext.dataset.productsPerPage =
      newPaginateNext.dataset.productsPerPage || "";
    currentPaginateNext.dataset.totalResults =
      newPaginateNext.dataset.totalResults || "";
    currentPaginateNext.innerHTML = newPaginateNext.innerHTML;
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });

    FacetFiltersForm.resetSizeFilterMarkers();

    FacetFiltersForm.filterSoldOutProducts();

    // Dispatch event to notify that products have been updated
    document.dispatchEvent(new CustomEvent("products:loaded"));

    if (typeof window.setupQuickAdd === "function") {
      setTimeout(() => {
        window.setupQuickAdd();
      }, 100);
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));

    //   const endlessCollection = new Ajaxinate({
    //     container: "#product-grid",
    //     pagination: ".infinite_next",
    //   });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const isInlineDetails = newFacetDetailsElement.classList.contains(
          "mobile-facets__details--inline"
        );
        const isMobileDetails = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        );
        const newElementSelector = isInlineDetails
          ? `.mobile-facets__summary`
          : isMobileDetails
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  static filterSoldOutProducts() {
    // Check if size filter is active and get the selected sizes
    const urlParams = new URLSearchParams(window.location.search);
    const selectedSizes = [];

    Array.from(urlParams.entries()).forEach(([key, value]) => {
      if (
        key.toLowerCase().includes("size") ||
        key.includes("filter.v.option.size") ||
        key.includes("filter.p.m.size")
      ) {
        selectedSizes.push(value.toLowerCase());
      }
    });

    if (selectedSizes.length === 0) return;

    // Get all product cards - use a more specific selector
    const productGrid = document.getElementById("product-grid");
    if (!productGrid) return;

    const productCards = productGrid.querySelectorAll(".card-wrapper");

    productCards.forEach((card) => {
      // Skip if already processed
      if (card.dataset.sizeFiltered === "true") return;

      // Look for variant data in the JSON script tag
      const variantDataScript = card.querySelector(".product-variant-data");

      if (variantDataScript) {
        try {
          const productData = JSON.parse(variantDataScript.textContent);
          const variants = productData.variants || [];

          const hasAvailableSize = variants.some((variant) => {
            const variantOptions = [
              variant.option1,
              variant.option2,
              variant.option3,
            ].filter((opt) => opt !== null && opt !== undefined);

            const matchesSelectedSize = variantOptions.some((option) =>
              selectedSizes.includes(option.toLowerCase())
            );

            return matchesSelectedSize && variant.available;
          });

          card.dataset.sizeFiltered = "true";

          const gridItem = card.closest(
            "li, .grid__item, [class*='grid-item']"
          );
          const targetElement = gridItem || card;

          if (!hasAvailableSize) {
            targetElement.remove();
          }
        } catch (e) {
          console.warn("Could not parse variant data:", e);
        }
      }
    });
  }

  static resetSizeFilterMarkers() {
    document.querySelectorAll('[data-size-filtered="true"]').forEach((card) => {
      card.dataset.sizeFiltered = "false";
    });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);

    searchParams.delete("us_price_min");
    searchParams.delete("us_price_max");

    const hasSizeFilter = Array.from(formData.entries()).some(
      ([key, value]) => {
        return (
          key.toLowerCase().includes("size") ||
          key.toLowerCase().includes("variant") ||
          key.includes("filter.v.option.size")
        );
      }
    );

    if (hasSizeFilter) {
      searchParams.append("variant", "instock");
    }

    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  submitFilters(event, formIds) {
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    const forms = [];

    sortFilterForms.forEach((form) => {
      if (formIds.includes(form.id)) {
        forms.push(this.createSearchParams(form));
      }
    });

    this.onSubmitForm(forms.join("&"), event);
  }

  closeFilterDropdown(button) {
    const details = button.closest("details");
    if (details) {
      details.removeAttribute("open");
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );

    // Don't auto-submit on mobile checkbox changes
    if (event.srcElement.className == "mobile-facets__checkbox") {
      return;
    }

    const forms = [];
    const isMobile =
      event.target.closest("form").id === "FacetFiltersFormMobile" ||
      event.target.closest("form").id === "FacetSortMobileForm";

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (
          form.id === "FacetSortForm" ||
          form.id === "FacetFiltersForm" ||
          form.id === "FacetSortDrawerForm"
        ) {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === "FacetFiltersFormMobile") {
        forms.push(this.createSearchParams(form));
      } else if (form.id === "FacetSortMobileForm") {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join("&"), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    const facetsApplyButton = event.target.closest(".facets__apply");
    if (facetsApplyButton) {
      event.preventDefault();
      const facetForm = facetsApplyButton.closest("facet-filters-form");
      if (!facetForm) return;

      const form = facetsApplyButton.closest("form");
      if (form && form.id === "FacetFiltersFormMobile") {
        facetForm.submitFilters(event, [
          "FacetFiltersFormMobile",
          "FacetSortMobileForm",
        ]);
      } else {
        facetForm.submitFilters(event, [
          "FacetSortForm",
          "FacetFiltersForm",
          "FacetSortDrawerForm",
        ]);
      }

      facetForm.closeFilterDropdown(facetsApplyButton);
      return;
    }

    if (event.target.classList.contains("mobile-facets__apply")) {
      const form = event.target.closest("form");
      if (form && form.id === "FacetFiltersFormMobile") {
        const facetForm = form.closest("facet-filters-form");
        if (facetForm) {
          const forms = [];
          const sortFilterForms = document.querySelectorAll(
            "facet-filters-form form"
          );
          sortFilterForms.forEach((f) => {
            if (
              f.id === "FacetFiltersFormMobile" ||
              f.id === "FacetSortMobileForm"
            ) {
              forms.push(facetForm.createSearchParams(f));
            }
          });
          facetForm.onSubmitForm(forms.join("&"), event);

          const drawer = form.closest(".mobile-facets__wrapper");
          if (drawer) {
            const summary = drawer.querySelector("summary");
            if (summary) {
              summary.click();
            }
          }
        }
      }
    }

    if (
      event.target.classList.contains("mobile-sort__apply") ||
      (event.target.closest("button") &&
        event.target.closest("button").classList.contains("mobile-sort__apply"))
    ) {
      const button = event.target.classList.contains("mobile-sort__apply")
        ? event.target
        : event.target.closest("button");
      const form = button.closest("form");
      if (form && form.id === "FacetSortMobileForm") {
        const facetForm = form.closest("facet-filters-form");
        if (facetForm) {
          const forms = [];
          const sortFilterForms = document.querySelectorAll(
            "facet-filters-form form"
          );
          sortFilterForms.forEach((f) => {
            if (
              f.id === "FacetFiltersFormMobile" ||
              f.id === "FacetSortMobileForm"
            ) {
              forms.push(facetForm.createSearchParams(f));
            }
          });
          facetForm.onSubmitForm(forms.join("&"), event);

          // Close the drawer
          const drawer = form.closest(".mobile-sort__wrapper");
          if (drawer) {
            const summary = drawer.querySelector("summary");
            if (summary) {
              summary.click();
            }
          }
        }
      }
    }
  });

  document.addEventListener("change", function (event) {
    if (event.target.type === "radio" && event.target.name === "sort_by") {
      const form = event.target.closest("form");
      if (form && form.id === "FacetSortMobileForm") {
        const allItems = form.querySelectorAll(".mobile-sort__item");
        allItems.forEach((item) =>
          item.classList.remove("mobile-sort__item--selected")
        );

        const selectedLabel = event.target.closest(".mobile-sort__item");
        if (selectedLabel) {
          selectedLabel.classList.add("mobile-sort__item--selected");
        }
      }
    }
  });
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

document.addEventListener("products:added", (event) => {
  console.log("products:added event caught - applying size filter");

  setTimeout(() => {
    FacetFiltersForm.filterSoldOutProducts();

    console.log("Size filter applied, reinitializing quick-add");

    if (typeof window.setupQuickAdd === "function") {
      window.setupQuickAdd();
    }

    if (window.cartManager) {
      window.cartManager.initialize();
    }
  }, 100);
});

document.addEventListener("products:loaded", () => {
  console.log("products:loaded event caught");

  setTimeout(() => {
    if (typeof window.setupQuickAdd === "function") {
      window.setupQuickAdd();
    }

    if (window.cartManager) {
      window.cartManager.initialize();
    }
  }, 100);
});

if (document.getElementById("product-grid")) {
  const observer = new MutationObserver((mutations) => {
    let hasNewProducts = false;

    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            (node.classList?.contains("grid__item") ||
              node.querySelector?.(".card-wrapper"))
          ) {
            hasNewProducts = true;
          }
        });
      }
    });

    if (hasNewProducts) {
      console.log(
        "MutationObserver detected new products - applying size filter"
      );

      setTimeout(() => {
        FacetFiltersForm.filterSoldOutProducts();

        if (typeof window.setupQuickAdd === "function") {
          window.setupQuickAdd();
        }

        if (window.cartManager) {
          window.cartManager.initialize();
        }
      }, 150);
    }
  });

  const productGrid = document.getElementById("product-grid");
  if (productGrid) {
    observer.observe(productGrid, {
      childList: true,
      subtree: true,
    });
  }
}
